module.exports = __webpack_public_path__ + "img/constelacao-1.f7bc3e9c.jpg";